<template>
    <div id="AppointmnetByEmployeeTypes">
        <h4 class="page-title text-truncate">
            {{ $t('employeeType.ApptByEmplTypeListTitle') }}
            <span v-if="selectedEmployeeCode"> - {{ selectedEmployeeDescription }}</span>
        </h4>
        <div class="row">
            <div class="col-12">
                <MdCheckListBox2
                    v-model="modelApptTypesIds"
                    v-bind:Options="appointmentTypeList"
                    v-bind:columnCount="4"
                    :ShowSearchInput="true"
                    :ShowSelectAll="true"
                    :textField="'description'"
                    :valueField="'code'"
                >
                </MdCheckListBox2>
            </div>
        </div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnapptByEmployeeTypeSetupList'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DiscardChanges"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="SaveApptByEmployeeTypes"
                v-bind:Name="'btn_save_apptByEmployeeTypes'"
            />
        </div>
    </div>
</template>
<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import AppointmentTypesService from '@/services/appointmenttypes.service';
import AppointmentByEmployeeTypeService from '@/services/appointmentbyemployeetype.service';
import { EventBus } from '../../../../../event-bus.js';
import Permission from '@/common/Permission';

let elemSaveBtn = '';

export default {
    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('Admission.Admission'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.SaveApptByEmployeeTypes();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    name: 'CalendarResources',
    mixins: [ShowMessage, DBFunctions, Permission /*,EventBus*/],
    data() {
        return {
            parameter: {
                SearchCriteria: '',
                PageNumber: 1,
                PageSize: 0
            },
            items: [],
            modelApptTypesIds: [],
            appointmentTypeList: [],
            selectedEmployeeCode: '',
            selectedEmployeeDescription: '',
            isReadOnly: false,
            totalRows: 0,
            perPage: 10,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            ShowMessageIsEmpty: false,
            CodeExist: false,
            pendingChanges: false,
            isModifierValid: true,
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },

    methods: {
        showApptTypesCheckBoxList(row) {
            console.log
            this.selectedEmployeeCode = row.code ? row.code.trim() : '';
            this.selectedEmployeeName = row.name
                ? row.name.trim()
                : row.description
                ? row.description.trim()
                : '';

            const param = {
                Code: this.selectedEmployeeCode
            };

            AppointmentByEmployeeTypeService.getAllAsync(param)
                .then(response => {
                    if (response && response.data) {
                        const items = Array.isArray(response.data) ? response.data : [];

                        this.modelApptTypesIds = items
                            .map(item => {
                                return item.appointmentType ? item.appointmentType.trim() : '';
                            })
                            .filter(code => code !== '');
                    }

                    this.VisibleApptTypesModal = true;
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        DiscardChanges() {
            this.checkExistFavorite('/app/appointmentbyemployeetypessetuplist');
            this.$router.push({ name: 'AppointmentByEmployeeTypesSetupList' });
        },

        getAppointmentTypes() {
            const param = {
                StopShowing: true
            };

            this.appointmentTypeList = [];

            return AppointmentTypesService.getAllbyParam(param)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        const data = response.data;
                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.apptTotalRows = this.Header.TotalCount;

                        data.forEach(element => {
                            this.appointmentTypeList.push({
                                code: element.code.trim(),
                                description: element.description ? element.description.trim() : ''
                            });
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async SaveApptByEmployeeTypes() {

            if (!this.selectedEmployeeCode) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
                return;
            }

            this.$emit('load', true);
            if (elemSaveBtn) {
                elemSaveBtn.setAttribute('disabled', '');
            }

            const payload = {
                employeeType: this.selectedEmployeeCode.trim(),
                appointmentTypes: this.modelApptTypesIds || []
            };

            AppointmentByEmployeeTypeService.insertAsync(payload)
                .then((response) => {
                    if (response.status == '200') {
                        this.pendingChanges = false;   
                        this.$emit('load', false);

                        setTimeout(() =>
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                        , 50);
                    }                             
                })
                .catch((error) => {   
                    elemSaveBtn.removeAttribute("disabled"); 
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        },

        checkUserAction() {
        if (elemSaveBtn.disabled) {
            elemSaveBtn.removeAttribute('disabled');
        }
        },
        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault()
                e.returnValue = ''
            }
        }
    },

    created() {
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    mounted() {
        this.selectedEmployeeCode = this.$route.params.id ? this.$route.params.id.trim() : '';
        this.selectedEmployeeDescription = this.$route.query.description ? this.$route.query.description.trim() : '';

        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.getAppointmentTypes().then(() => {
            if (this.selectedEmployeeCode) {
                this.showApptTypesCheckBoxList({ code: this.selectedEmployeeCode });
            }
        });

        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_apptByEmployeeTypes');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
